module.exports = __webpack_public_path__ + "static/media/abundance-blur-bundle-167538 copy.f987677b.jpg";